<template>
	<!-- begin #footer -->
	<div id="footer" class="footer">
		&copy; 2020 ПК КНУ.
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions
		}
  }
}
</script>
